import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { CONDITION, LOCATION, PART_ID } from "MODULES/inventories/constants";
import { QUANTITY } from "APP_ROOT/constants";
import { RECEIVING_TYPE } from "MODULES/Receiving/constants";

export default function validate(values) {
  return validator(values, form => {
    form
      .validate(RECEIVING_TYPE, PART_ID, CONDITION, QUANTITY, LOCATION)
      .satisfies(rules.required);
  });
}



// WEBPACK FOOTER //
// ./app/modules/Receiving/Edit/validate.js